/**
 * Created by jv on 15/05/2018.
 */
import CONSTANTS from "Sources/games/chicken-game/config/constants";
import getText from "Sources/games/chicken-game/config/text";
let Text;

const MAIN_MENU = "main-menu";
const PAUSE_MENU = "pause-menu";

export default class Menu extends Phaser.Scene
{
  constructor()
  {
    super({ key: "Menu" });

    this.type = MAIN_MENU;;
  }

  init({ type })
  {
    Text = getText();
    
    if(type === MAIN_MENU || type === PAUSE_MENU)
    {
      this.type = type;
    }

    if(typeof this.type === "undefined" || this.type === null)
    {
      this.type = MAIN_MENU;
    }

    if(this.type === PAUSE_MENU)
    {
      this.scene.setVisible(false);
    }
  }

  create()
  {
    this.createBackground();

    this.createText();

    this.createButton();
  }

  createBackground()
  {
    var gameWidth = this.sys.game.config.width;
    var gameHeight = this.sys.game.config.height;

    if(this.type === MAIN_MENU)
    {
      this.add.image(0, 0, CONSTANTS.ATLAS_KEY, "scene/sand.jpg").setOrigin(0, 0).setDisplaySize(gameWidth, gameHeight);
      this.add.image(0, 0, CONSTANTS.ATLAS_KEY, "scene/grass.png").setOrigin(0, 0).setDisplaySize(gameWidth, gameHeight);
      this.add.image(0, 0, CONSTANTS.ATLAS_KEY, "scene/fence.png").setOrigin(0, 0).setDisplaySize(gameWidth, gameHeight);
    }

    this.backdrop = this.add.image(0, 0, CONSTANTS.ATLAS_KEY, "misc/bg_overlay.png").setOrigin(0, 0);
    this.backdrop.setDisplaySize(gameWidth, gameHeight);

    var cloud = this.add.image(0, 0, CONSTANTS.ATLAS_KEY, "misc/background_cloud.png").setOrigin(0);
    cloud.setDisplaySize(gameWidth, gameHeight);
    // cloud.createBitmapMask();
    // paint.setMask(cloud);
  }

  createText()
  {
    var gameWidth = this.sys.game.config.width;
    var gameHeight = this.sys.game.config.height;

    this.title = this.add.text(gameWidth / 2, 25, Text.menu.title, { fontFamily: "RabbitOnTheMoon", fontSize: 28, fontWeight: "normal", fill: "#FFFFFF", align: "center" }).setOrigin(0.5, 0).setPadding(15);
    this.controlsText = this.add.text(gameWidth / 2, this.title.y + this.title.height, Text.menu.controlsDescription, { fontFamily: "AbadiMTPro-CondExtraBold", fontSize: 18, fontWeight: "normal", fill: "#FFFFFF", align: "center" }).setOrigin(0.5, 0).setPadding({ bottom: 15 });

    this.menuImage = this.add.image(gameWidth / 2, this.controlsText.y + this.controlsText.height, CONSTANTS.ATLAS_KEY, "misc/menu_chicks.png").setOrigin(0.5, 0);
  }

  createButton()
  {
    const CENTER = {
      x: this.cameras.main.width / 2,
      y: this.cameras.main.height / 2
    };

    const buttonImage = this.add.image(CENTER.x, this.menuImage.y + this.menuImage.height + 15, CONSTANTS.ATLAS_KEY, "misc/button.png").setOrigin(0.5, 0);
    const playIconWidth = this.scene.systems.game.textures.getFrame(CONSTANTS.ATLAS_KEY, "misc/icon_play.png").realWidth;
    const btnText = this.type === PAUSE_MENU ? Text.menu.resumeBtn : Text.menu.playBtn
    const startButtonText = this.add.text(CENTER.x + playIconWidth, buttonImage.y + buttonImage.height / 2, btnText, { fontFamily: "AbadiMTPro-CondExtraBold", fontSize: 21, fill: "#ffffff" }).setOrigin(0.5).setPadding({ left: 15 });
    const playIcon = this.add.image(startButtonText.x - startButtonText.width / 2, startButtonText.y, CONSTANTS.ATLAS_KEY, "misc/icon_play.png").setOrigin(1, 0.5);

    //  Handle the click or tap of the button using an input zone slightly
    //  bigger than the text object.
    this.playBtnZone = this.add.zone(
      buttonImage.x - (buttonImage.width * buttonImage.originX) - 5,
      buttonImage.y - (buttonImage.height * buttonImage.originY) - 5,
      buttonImage.width + 10,
      buttonImage.height + 10
    )
      .setName("play-button")
      .on("pointerover", (e) =>
      {
        this.input.mouse.target.style.cursor = "pointer";
      })
      .on("pointerout", (e) =>
      {
        this.input.mouse.target.style.cursor = "";
      });

    this.setPlayBtnEvent();

    if(this.type === MAIN_MENU)
    {
      this.setInteractive();
    }
  }

  setPlayBtnEvent()
  {
    this.playBtnZone.once("pointerup", () =>
    {
      this.input.mouse.target.style.cursor = "";

      if(this.type === PAUSE_MENU)
      {
        this.events.emit("resume-btn-clicked");
        this.setPlayBtnEvent();
      }
      else
      {
        this.scene.start("Game");
      }
    });
  }

  setInteractive(flag)
  {
    if(flag !== false)
    {
      if(this.playBtnZone)
      {
        this.playBtnZone.setInteractive();
      }
    }
    else
    {
      if(this.playBtnZone)
      {
        this.playBtnZone.removeInteractive();
      }
    }

    return this;
  }

  setVisible(flag)
  {
    if(flag)
    {
      this.setInteractive(flag !== false);
    }
    else
    {
      this.setInteractive(flag !== false);
    }

    this.scene.setVisible(flag);

    return this;
  }
}



// WEBPACK FOOTER //
// ./app/js/games/chicken-game/scenes/menu.js